<template>
  <div>
    <slot name="label">
      <div class="d-flex justify-content-between align-items-center">
        <label class="font-semi-bold m-0 d-block">{{ title }}</label>
        <LinkPlusComponent onlyIcon @onClick="onAddCarrier" />
      </div>
    </slot>

    <el-autocomplete
      v-model="carrierName"
      :placeholder="placeholder"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      @select="onSelect"
      suffix-icon="el-icon-search"
    >
      <template slot-scope="{ item }">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ item.name }}</span>
          <small v-if="item.plate" class="text-muted">{{ item.plate }}</small>
        </div>
      </template>
    </el-autocomplete>

    <el-dialog
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="() => (dialogVisible = false)"
    >
      <EditCarrierComponent
        v-if="dialogVisible"
        :carrier="{}"
        @saved="onCarrierCreated"
        @close="dialogVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import LinkPlusComponent from "@/modules/dashboard/components/LinkPlus";
import EditCarrierComponent from "../business/components/EditCarrier";
import businessService from "../business/services/businessService";

export default {
  name: "SelectCarrierComponent",
  components: { LinkPlusComponent, EditCarrierComponent },
  props: {
    title: { default: "Transportista" },
    placeholder: { default: "Buscar transportista" },
    setCarrierId: { default: null }
  },
  data: () => ({
    carrierName: "",
    carriers: [],
    dialogVisible: false
  }),
  methods: {
    async querySearch(queryString, cb) {
      if (queryString.length < 2) {
        cb([]);
        return;
      }
      try {
        const response = await businessService.getCarriers({
          params: { search: queryString, per_page: 20 }
        });
        if (response.data.success) {
          cb(
            response.data.carriers.map(c => ({
              ...c,
              value: c.name
            }))
          );
        } else {
          cb([]);
        }
      } catch (e) {
        cb([]);
      }
    },
    onSelect(item) {
      this.carrierName = item.name;
      this.$emit("onChangeSelect", { carrier: item });
    },
    onAddCarrier() {
      this.dialogVisible = true;
    },
    onCarrierCreated({ carrier }) {
      if (carrier) {
        this.carrierName = carrier.name;
        this.$emit("onChangeSelect", { carrier });
      }
      this.dialogVisible = false;
    },
    async loadInitialCarrier() {
      try {
        const response = await businessService.getCarriers({
          params: { per_page: 100 }
        });
        if (response.data.success) {
          const found = response.data.carriers.find(
            c => c.id === this.setCarrierId
          );
          if (found) {
            this.carrierName = found.name;
          }
        }
      } catch (e) {
        // silent
      }
    }
  },
  mounted() {
    if (this.setCarrierId) {
      this.loadInitialCarrier();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-autocomplete {
  width: 100% !important;
}
</style>
